import { render } from "./TableComp.vue?vue&type=template&id=d073fe5a&scoped=true"
import script from "./TableComp.vue?vue&type=script&lang=js"
export * from "./TableComp.vue?vue&type=script&lang=js"

import "./TableComp.vue?vue&type=style&index=0&id=d073fe5a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d073fe5a"]])

export default __exports__